export const environment = {
  production: true,
  envName: 'develop',
  apiBaseUrl: 'https://www.api-dev.physicalmerchtem.be',
  keycloak: {
    url: 'https://www.auth-dev.bitbeavers.be',
    realm: 'physical-power-club',
    clientId: 'ppc-fo-fe',
  },
};
